import React from 'react';
import { getLottoErrorMessage } from '../../utils/error';
import classes from './WidgetError.module.scss';

const WidgetError = ({ onRetry, error }) => (
  <div className={classes.Container}>
    <p className={classes.Text}>{getLottoErrorMessage(error)}</p>
    <button type="button" onClick={onRetry} className={classes.RetryButton}>
      Try Again
    </button>
  </div>
);

export default WidgetError;
